import { render } from "./TradePermit.vue?vue&type=template&id=78a51a00&scoped=true"
import script from "./TradePermit.vue?vue&type=script&lang=js"
export * from "./TradePermit.vue?vue&type=script&lang=js"

import "./TradePermit.vue?vue&type=style&index=0&id=78a51a00&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a51a00"]])

export default __exports__